// extracted by mini-css-extract-plugin
export var container = "_5e-0";
export var containerTopRight = "_5e-1";